export enum LifecycleStatus {
    Planned = 'Planned',
    In_Progress = 'In_Progress',
    Suspended = 'Suspended',
    Completed = 'Completed',
    Closed = 'Closed',
    Cancelled = 'Cancelled',
    Retired = 'Retired',
}
